import { render, staticRenderFns } from "./BindPhone.vue?vue&type=template&id=4fa1b8f7&scoped=true"
import script from "./BindPhone.vue?vue&type=script&lang=js"
export * from "./BindPhone.vue?vue&type=script&lang=js"
import style0 from "./BindPhone.vue?vue&type=style&index=0&id=4fa1b8f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa1b8f7",
  null
  
)

export default component.exports